/*global SimpleBar*/

angular.module('services')
	.service('popupService', [
		'$timeout', '$interval', 'mainUtils', '$window',
		function ($timeout, $interval, mainUtils, $window) {
			let browserInfo = mainUtils.getBrowserInfo();
			if (_.includes(['iOS', 'iPadOS'], browserInfo.osName) && parseInt(browserInfo.browserVer) <= 9) {
				document.documentElement.classList.add('iOSold');
			}
			var service = function (val) {
				var $element = $('.popup:visible').length ? $('.popup:visible') : false,
					interval = $interval(function () {
						if (val === '') {
							$interval.cancel(interval);
							return;
						}
						var $nextElem = $('.popup[ng-if="popup == \'' + val + '\'"]:visible');
						if ($nextElem.length) {
							scrollBar();
							$interval.cancel(interval);
						}
					}, 200);

				function scrollBar() {
					var $scrollElem = $element.find('.simplebar-content'),
						$simpleBarEl = $element.find('[data-simplebar]');
					if (mainUtils.getBrowserInfo().browserName === 'ie' && $simpleBarEl.length) {
						new SimpleBar($simpleBarEl[0]);
					}
					if ($scrollElem.length) {
						if ($scrollElem.css('overflow') === 'hidden') {
							$scrollElem.find('.infoBox__list_scroll').css({ marginRight: 0 });
						} else {
							$scrollElem.find('.infoBox__list_scroll').css({ marginRight: '' });
						}
					}
				}

				$timeout(function () {
					if ($element.is(':visible')) {
						scrollBar();
						$interval.cancel(interval);
					}
				});
			};

			service.init = function (scope) {
				Object.defineProperty(scope, 'popup', {
					get: function () {
						return this.value;
					},
					set: function (val) {
						if (angular.isUndefined(val) && val !== '') {
							history.pushState({}, 'Title', window.location.href);
						}
						service(val);
						this.value = val;
					}
				});
			};

			$window.addEventListener('resize', () => {
				let vh = $window.innerHeight * 0.01;
				document.documentElement.style.setProperty('--vh', `${vh}px`);
			});
			angular.element($window).triggerHandler('resize');

			return service;
		}]);